// ============================================================
// useTeamPath — uvijek vraća /t/:slug/... linkove ako imamo slug.
// Ovo osigurava da UI navigacija bude deterministička i neovisna
// o trenutnoj ruti. Legacy rute (/, /schedule, /profile…) i dalje
// rade za bookmark pristup, ali se iz UI-ja više ne pojavljuju.
//
// Funkcija je memoizirana s useCallback pa je sigurno stavljati
// je u useEffect/useMemo deps array.
//
// Primjer:
//   const tp = useTeamPath();
//   <Link to={tp('/schedule')}>…</Link>
//   history.push(tp(`/match/${id}`));
// ============================================================

import { useCallback } from 'react';
import { useTeam } from '../contexts/TeamContext';

export const useTeamPath = () => {
  const { slug } = useTeam();

  return useCallback(
    (path = '') => {
      const normalized = path.startsWith('/') ? path : `/${path}`;

      if (!slug) {
        return normalized;
      }

      // Path je već team-scoped — ostavi kako je.
      if (normalized.startsWith('/t/')) {
        return normalized;
      }

      if (normalized === '/') {
        return `/t/${slug}`;
      }

      return `/t/${slug}${normalized}`;
    },
    [slug]
  );
};

export default useTeamPath;
